import React from "react";
import "./pricing.css";

const skills = [
  { id: 1, name: "HTML" },
  { id: 2, name: "CSS" },
  { id: 3, name: "JavaScript" },
  { id: 4, name: "React" },
  { id: 5, name: "React Native" },
  { id: 6, name: "Next" },
  { id: 7, name: "Redux" },
  { id: 8, name: "TypeScript" },
  { id: 9, name: "Java" },
  { id: 10, name: "SQL" },
  { id: 11, name: "Node" },
  { id: 12, name: "Firebase" },
  { id: 13, name: "Postman" },
  { id: 14, name: "GitHub" },
  { id: 15, name: "Material-UI" },
  { id: 16, name: "Tailwind CSS" },
];

function Pricing(props) {
  return (
    <section className="resume container section" id="resume">
      <h2 className="section__title">My Skills</h2>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          marginTop: "20px",
        }}
      >
        {skills.map((tech) => (
          <div
            key={tech.id}
            className="tech-box"
            style={{
              borderRadius: "8px",
              padding: "10px",
              margin: "10px",
              width: "auto",
              backgroundColor: "white",
              boxShadow: "0 5px 20px 0px rgba(0, 0, 0, 0.1)",
              transition: "box-shadow 0.3s ease-in-out",
            }}
          >
            <h3
              style={{
                color: "#5e5c7f",
              }}
            >
              {tech.name}
            </h3>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Pricing;
